import { IconifyIcon, InlineIcon } from '@iconify/react';
import * as React from 'react';
import UIFlex, { IUIFlexProps } from './UIFlex';
import './UIIcon.scss';
import closeIcon from '@iconify/icons-mdi/close';
import plusBoldIcon from '@iconify/icons-mdi/plus-bold';
import reloadIcon from '@iconify/icons-mdi/reload';
import chevronUp from '@iconify/icons-mdi/chevron-up';
import chevronDown from '@iconify/icons-mdi/chevron-down';
import chevronLeft from '@iconify/icons-mdi/chevron-left';
import chevronRight from '@iconify/icons-mdi/chevron-right';
import pencilIcon from '@iconify/icons-mdi/pencil';
import searchLocation from '@iconify/icons-fa-solid/search-location';
import dragVerticalVariant from '@iconify/icons-mdi/drag-vertical-variant';
import checkCircle from '@iconify/icons-mdi/check-circle';
import checkIcon from '@iconify/icons-mdi/check-bold';
import cancelIcon from '@iconify/icons-mdi/cancel';
import loadingIcon from '@iconify/icons-mdi/loading';
import userIcon from '@iconify/icons-mdi/user';
import logoutIcon from '@iconify/icons-mdi/log-out';
import copyIcon from '@iconify/icons-mdi/content-copy';
import fullscreenIcon from '@iconify/icons-mdi/fullscreen';
import fullscreenExitIcon from '@iconify/icons-mdi/fullscreen-exit';
import deleteUser from '@iconify/icons-mdi/delete';
import manageUser from '@iconify/icons-mdi/account-badge';
import userProfile from '@iconify/icons-mdi/face-profile';
import Size from '../data/Size';


export interface IUIIconProps extends IUIFlexProps{
    className?:string;
    icon?:string | IconifyIcon;
    customImgIcon?:string;
    fontSize?:string;
}

//using class so we can havce static ICONs easily referenced
export default class UIIcon extends React.PureComponent<IUIIconProps> {
    /*
    ICONS
    */
    static CLOSE:IconifyIcon = closeIcon;
    static EDIT:IconifyIcon = pencilIcon;
    static ADD:IconifyIcon = plusBoldIcon;
    static RELOAD:IconifyIcon = reloadIcon;
    static SEARCH_LOCATION:IconifyIcon = searchLocation;
    static DRAG_VERTICAL:IconifyIcon = dragVerticalVariant;
    static CHEVRON_UP:IconifyIcon = chevronUp;
    static CHEVRON_DOWN:IconifyIcon = chevronDown;
    static CHEVRON_LEFT:IconifyIcon = chevronLeft;
    static CHEVRON_RIGHT:IconifyIcon = chevronRight;
    static CHECK_CIRCLE:IconifyIcon = checkCircle;
    static CHECK:IconifyIcon = checkIcon;
    static CANCEL:IconifyIcon = cancelIcon;
    static LOADING:IconifyIcon = loadingIcon;
    static USER:IconifyIcon = userIcon;
    static LOGOUT:IconifyIcon = logoutIcon;
    static FULLSCREEN:IconifyIcon = fullscreenIcon;
    static FULLSCREEN_EXIT:IconifyIcon = fullscreenExitIcon;
    static COPY:IconifyIcon = copyIcon;
    static DELETE_USER:IconifyIcon = deleteUser;
    static MANAGE_USER:IconifyIcon = manageUser;
    static USER_PROFILE:IconifyIcon= userProfile;
    

    render() {
        let cn:string = "icon "+(this.props.className || "");

        cn = Size.addFontSize(cn, this.props.fontSize);

        return (
            <UIFlex className={cn} flex={this.props.flex}>
                {this.props.icon && (
                    <InlineIcon icon={this.props.icon}/>
                )}
                {this.props.customImgIcon && (
                    <img src={this.props.customImgIcon} alt=""/>
                )}
                {this.props.children}
            </UIFlex>
        );
    }
}



